import React, { useState, useEffect } from 'react'

import {
  Alert,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material'
import { OPERATION_TYPES } from 'utils/constants/operationTypes'
import moment from 'moment'

import { getContractOfAdhesionDownloadLink } from 'services/apiKYP'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { Refresh } from '@mui/icons-material'
import QuestionButton from '../QuestionButton'
import styles from './styles'

export default function AdesionTerms(props) {
  const classes = styles()

  const { questionData, saveResponses } = props

  const [agreed, setAgreed] = useState(questionData.answer?.agreed === true)

  const [termsAcceptedAt, setTermsAcceptedAt] = useState(
    questionData.answer.terms_accepted_at || '',
  )

  const [loading, setLoading] = useState(false)

  const [ethicsCodeFileLink, setEthicsCodeLink] = useState('')
  const [complianceManualFileLink, setComplianceManualLink] = useState('')
  const [auditRegulationFileLink, setAuditRegulationLink] = useState('')
  const [errorLoadingContractOfAdhesion, setErrorLoadingContractOfAdhesion] = useState(false)

  const token = useSelector((state) => state.auth.access_token)

  const [saved, setSaved] = useState(questionData.answer?.agreed === true)

  const handleAgree = (event) => {
    setAgreed(event.target.checked)
    setTermsAcceptedAt(moment().format('YYYY-MM-DDThh:mm:ss'))
  }

  const saveResponse = async () => {
    const answer = {
      agreed: agreed,
      terms_accepted_at: termsAcceptedAt,
    }
    setLoading(true)
    await saveResponses(
      { has_answer: true, answer: answer },
      'terms_agreement',
      !saved ? OPERATION_TYPES.CREATE : OPERATION_TYPES.UPDATE,
    )
      .then(() => {
        setSaved(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const fetchContractOfAdhesion = () => {
    getContractOfAdhesionDownloadLink(token, 'ethics_code')
    .then((response) => {
      setEthicsCodeLink(response.data.document_url)
    })
    .catch(() => {
      setErrorLoadingContractOfAdhesion(true)
    })
  getContractOfAdhesionDownloadLink(token, 'compliance_manual')
    .then((response) => {
      setComplianceManualLink(response.data.document_url)
    })
    .catch(() => {
      setErrorLoadingContractOfAdhesion(true)
    })
  getContractOfAdhesionDownloadLink(token, 'audit_regulation')
    .then((response) => {
      setAuditRegulationLink(response.data.document_url)
    })
    .catch(() => {
      setErrorLoadingContractOfAdhesion(true)
    })
  }

  const isContractOfAdhesionFecthed = () => {
    return !_.isEmpty(ethicsCodeFileLink) &&
    !_.isEmpty(complianceManualFileLink) &&
    !_.isEmpty(auditRegulationFileLink)

  }
    
  useEffect(() => {
    setSaved(questionData.answer?.agreed === true)
  }, [questionData])

  useEffect(() => {
    fetchContractOfAdhesion()
  }, [])

  useEffect(() => {
    if (isContractOfAdhesionFecthed()) {
      setErrorLoadingContractOfAdhesion(false)
    }
  }, [ethicsCodeFileLink, complianceManualFileLink, auditRegulationFileLink])

  return (
    <div className={classes.root}>
      <h3>Termos de adesão</h3>
      <FormLabel>
        Enquanto profissional que se encontra em processo de credenciamento na XP Inc.:
      </FormLabel>
      <ol>
        <div>
          <li>
            <p>
              Declaro para todos os fins que acessei, li e compreendi o Regulamento de Auditoria de
              Assessor de Investimento, o Código de Ética e Conduta de Assessor de Investimento e o
              Manual de Compliance de Assessor de Investimento, além das demais políticas e/ou
              normas internas da XP disponibilizadas na Expert do Assessor (Menu &gt; B2B &gt;
              Compliance).
            </p>
          </li>
          <li>
            <p>
              Declaro ainda cumprir e continuar cumprindo totalmente todos os procedimentos, regras
              e normas estabelecidos nestes documentos e em todas as políticas e regras de atuação
              que normatizarem a atuação do Assessor de Investimento.
            </p>
          </li>
          <li>
            <p>
              Declaro que acessei, li, tenho conhecimento e cumprirei integralmente todas as
              diretrizes das Políticas Internas citadas nos referidos documentos, bem como outras
              políticas aplicáveis da XP ao Assessor de Investimento.
            </p>
          </li>
          <li>
            <p>
              Comprometo-me a seguir todas as orientações estabelecidas nos documentos, bem como
              quaisquer atualizações que ocorreram durante a vigência da minha relação com a XP,
              tendo ciência de que o não cumprimento das regras aplicáveis incidirá na aplicação das
              medidas cabíveis.
            </p>
          </li>
          <li>
            <p>
              Estou ciente que não poderei alegar o não conhecimento destas políticas para
              justificar quaisquer descumprimentos.
            </p>
          </li>
        </div>
      </ol>

      {errorLoadingContractOfAdhesion && (
        <Alert style={{ width: '100%', alignItems: 'center', gap: 1 }} severity="error">
          Ocorreu um erro ao carregar o restante dos termos de adesão.
          
          <Button size='small' onClick={() => fetchContractOfAdhesion()} startIcon={<Refresh fontSize='small'></Refresh>}>Tentar novamente</Button>
        </Alert>
      )}

      {!errorLoadingContractOfAdhesion && (
        <React.Fragment>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreed}
                  onChange={handleAgree}
                  disabled={saved || !isContractOfAdhesionFecthed()}
                />
              }
              label={
                <p>
                  Declaro que li e concordo com os termos de adesão descritos acima, bem como os
                  termos descritos no <a href={ethicsCodeFileLink} target='_blank'>Código de Ética e Conduta</a>, no{' '}
                  <a href={complianceManualFileLink} target='_blank'>Manual de Compliance</a> e no{' '}
                  <a href={auditRegulationFileLink} target='_blank'>Regulamento de Auditoria</a>, aqui disponíveis.
                </p>
              }
            />
          </FormGroup>
          <div className={classes.buttonsContainer}>
            <QuestionButton
              variant="contained"
              onClick={saveResponse}
              loading={loading}
              saved={saved}
              disabled={!agreed || saved || !isContractOfAdhesionFecthed()}
            >
              {saved ? 'Resposta salva' : 'Salvar Resposta'}
            </QuestionButton>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}
